import React, {Component} from 'react';
import { connect } from 'react-redux';

// An HOC which will navigate user back to the login
// page if the user try to reach some pages without
// being authenticated.

export default function (PurchaseDashboard, WarehouseDashboard, SalesDashboard) {
    class UserBasedAuthentication extends Component {
        static contextTypes = {
            router: React.PropTypes.object
        }

        componentDidMount() {
            if (!this.props.authenticated) {
                this.context.router.push('/login')
            }
        }

        componentWillUpdate(nextProps) {
            if (!nextProps.authenticated) {
                this.context.router.push('/login')
            }
        }

        render() {
            if (this.props.userType == "w") {
              return <WarehouseDashboard {...this.props} />
            } else if (this.props.userType == "s") {
              return <SalesDashboard {...this.props} /> 
            } else {
              return <PurchaseDashboard {...this.props} />
            }
        }
    }

    function mapStateToProps(state) {
        return { authenticated: state.auth.authenticated,
                 userType     : state.auth.userType }
    }
    return connect(mapStateToProps)(UserBasedAuthentication);
}



// WEBPACK FOOTER //
// ./master/jsx/containers/Auth/userBased_auth.jsx